import { ObjectValues } from '../../app/types/utilityTypes';

export const LID_STATUSES = {
  MET: 'Requirements Met',
  CLOSE: 'Requirements Almost Met',
  NOT_MET: 'Requirements Not Met',
} as const;

export type LidStatus = ObjectValues<typeof LID_STATUSES>;
